// prerender.js
export function markPrerenderReady() {
	if (typeof window !== "undefined") {
		window.prerenderReady = true;
	}
}

export function resetPrerenderReady() {
	if (typeof window !== "undefined") {
		window.prerenderReady = false;
	}
}
